export default {

    tooltipBackground: {
        background: "#EFF5FD",
        opacity: "1",
        zIndex: "99",
        boxShadow: "0px 4px 6px rgba(154, 159, 169, 0.25)",
        width: "300px",
        padding: "10px 17px",
        borderRadius: "10px",
        fontFamily: 'Lato',
        fontWeight: "400",
        fontSize: "12px",
        color: "#252323",
    },

}